import { formatsByName } from '@ace_domains/address-encoder'

const COIN_LIST = ['ACE']
// const COIN_LIST = Object.keys(formatsByName)

export default COIN_LIST
